import { styled } from '@/src/stitches.config'
import {
    BackButton,
    BlueLine,
    LeftContentWrapper,
    RightContentWrapper,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import Card from '@/src/common/components/marketing/cards/Card'
import { currencyFormatter } from '@/src/common/utilities/currencyFormatter'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { DISPATCH_SET_STEP } from '@/src/common/reducers/constants'
import {
    GIFT_DETAILS_STEP,
    REDEMPTION_SELECT_STEP,
} from '@/src/modules/pg-plus/redemption/constants'
import PlasticExchangeAddressForm from '@/src/modules/pg-plus/redemption/forms/PlasticExchangeAddressForm'

const Wrapper = styled('div', {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    jc: 'space-between',
    ai: 'center',
    '@media (min-width: 765px)': {
        flexDirection: 'row',
        ai: 'unset',
    },
})

const StyledLeftContentWrapper = styled(LeftContentWrapper, {
    pb: 50,
    '.margin-top': {
        mt: 30,
    },
    '@media (min-width: 765px)': {
        width: 450,
        maxWidth: '50%',
    },
})
const StyledRightContentWrapper = styled(RightContentWrapper, {
    py: 20,
    '.small-text': {
        fontSize: '.8rem',
        margin: '25px auto auto',
    },
    '@media (min-width: 765px)': {
        maxWidth: '50%',
        pt: 40,
    },
})

const StyledH1 = styled('h1', {
    maxWidth: '100%',
    '@media (min-width: 765px)': {
        width: 350,
    },
})

interface IPlasticDelivery {
    setIsRedeemed?: Function | null
    showBackButton?: boolean
    hasBeenCardLinked: boolean
    refetchGift: Function
}

const PlasticExchangeDelivery = ({
    setIsRedeemed = null,
    showBackButton = true,
    hasBeenCardLinked,
    refetchGift,
}: IPlasticDelivery) => {
    const { dispatch, giftState } = usePGPlusStepAndModalContext()
    const { denomination } = giftState
    const denomInDollars = currencyFormatter(denomination)
    const marginTopValue = showBackButton ? '' : 0

    return (
        <Wrapper>
            <StyledLeftContentWrapper>
                {showBackButton && (
                    <BackButton
                        onClick={() => {
                            dispatch({
                                type: DISPATCH_SET_STEP,
                                payload: {
                                    stepName: hasBeenCardLinked
                                        ? GIFT_DETAILS_STEP
                                        : REDEMPTION_SELECT_STEP,
                                },
                            })
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            style={{ marginRight: '0.5rem' }}
                        />
                        &nbsp;Back
                    </BackButton>
                )}
                <BlueLine style={{ marginTop: marginTopValue }} />{' '}
                <StyledH1 data-testid={'plastic-redemption'}>
                    Get a plastic{' '}
                    <span className={'gradient'}>Visa gift card</span> in the
                    mail
                </StyledH1>
                <p data-testid={'denom-text'}>
                    You will receive a Visa gift card in the mail within 1-5
                    business days with a balance of {denomInDollars}.
                </p>
                <PlasticExchangeAddressForm
                    setIsRedeemed={setIsRedeemed}
                    showSuccessStep={!hasBeenCardLinked}
                    refetchGift={refetchGift}
                />
            </StyledLeftContentWrapper>
            <StyledRightContentWrapper backgroundColor={'none'}>
                <Card
                    size={'lg'}
                    image={'/images/visa_exchange_image.png'}
                    isExtended={false}
                    overlayType={'none'}
                    priority={true}
                    data-testid={'visa-image'}
                />
            </StyledRightContentWrapper>
        </Wrapper>
    )
}

export default PlasticExchangeDelivery
